<template>
  <a-modal
    title="选择小组和讲次"
    centered
    width="calc(100% - 80px)"
    :visible="visible"
    :closable="false"
    :mask-closable="false"
    @cancel="handleCancel"
  >
    <div class="table-wrapper">
      <div class="table-filter">
        <div class="filter">
          <a-input
            placeholder="搜索小组名称"
            style="width: 130px"
            class="filter-selection"
            allow-clear
            v-model="searchGroupName"
          />
          <a-input
            placeholder="学习机课程名称"
            style="width: 144px"
            class="filter-selection"
            allow-clear
            v-model="searchItvCourseName"
          />
          <template>
            <span class="filter-selection">学年学期</span>
            <YearSemesterSelect class="mr8" ref="yearAndSemester" @updateYearAndSemester="updateYearAndSemester" />
          </template>
          <template>
            <span class="filter-selection">期次</span>
            <a-select style="width: 80px;" class="select mr8" :value="activePeriod" @change="(val) => selectionChange(val, 'Period')">
              <a-select-option :value="item.id" v-for="item in periodList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template>
            <span class="filter-selection">周期</span>
            <a-select style="width: 80px;" class="select mr8" v-model="activeClassCycle" @change="(val) => selectionChange(val, 'ClassCycle')">
              <a-select-option :value="item.id" v-for="item in classCycleList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template>
            <span class="filter-selection">时段</span>
            <a-select class="select mr8" v-model="activeTimeInterval" @change="(val) => selectionChange(val, 'TimeInterval')">
              <a-select-option :value="item.id" v-for="item in timeIntervalList" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </template>
          <template>
            <a-button type="primary" class="mr8" @click="doSearch">
              搜索
            </a-button>
          </template>
          <template>
            <a-button @click="reset" class="ant-btn-secondary">
              重置
            </a-button>
          </template>
        </div>
      </div>
      <div class="list-box">
        <div class="group-list-box">
          <!-- :custom-row="customRowFun" 加上后表格渲染出问题-->
          <!-- :custom-row="customRowFun" -->
          <a-table
            row-key="id"
            :table-layout="auto"
            :scroll="scroll"
            :loading="loading"
            :columns="columns"
            :data-source="tesTableData"
            :pagination="false"
            :custom-row="customRowFun"
            :row-selection="{
              selectedRowKeys: selectedRowKeys,
              onSelect: onSelect,
              onSelectAll: onSelectAll,
              onChange: onChange,
            }"
          >
            <span slot="groupName" class="plan-name text-limit" slot-scope="text" :title="text">
              {{ text }}
            </span>
            <span slot="studentNum" class="text-num" slot-scope="text">{{ text }}</span>

            <span slot="courseTime" class="title-dom">
              时间
            </span>
            <span slot="openTime" slot-scope="text, record">
              {{ record | formatTimeStr }}
            </span>
            <span slot="itvCourseName" slot-scope="text" :title="text" class="text-limit">
              {{ text || '--' }}
            </span>
            <span slot="semester" slot-scope="text, record">
              {{ record.year > 0 && record.semester ? (record.year + ' ' + record.semester) : '--' }}
            </span>
            <span slot="periodStr" slot-scope="text, record">{{ record.periodStr || '--' }}</span>
            <span slot="classCycleStr" slot-scope="text, record" :title="text">{{ record.classCycleStr || '--' }}</span>
            <span slot="timeIntervalStr" slot-scope="text, record" :title="text">{{ record.timeIntervalStr || '--' }}</span>
          </a-table>
          <div class="pagination">
            <a-pagination
              v-show="pagination.total > 0"
              v-model="pagination.current"
              :total="pagination.total"
              :page-size="pagination.pageSize"
              @change="handleChangePageNum"
            />
          </div>
        </div>
        <!-- 已选小组 -->
        <div class="batch-wap-right">
          <div class="head">
            <div class="hasSelect">
              已选({{ selectedRows.length }}组)
            </div>
            <div class="clearAll" @click="clearAll">
              清空
            </div>
          </div>
          <p class="group-lesson-tip">
            <SvgIcon icon="exclamation-mark" class="info-icon" />
            点击小组可选择讲次
          </p>
          <a-radio-group class="radio-group" v-if="selectedRows.length>0" v-model="currentGroupId" :default-value="selectedRows[0].id">
            <a-radio-button
              :value="item.id"
              v-for="(item, index) in selectedRows"
              :key="item.id"
              class="radio-item"
            >
              <div class="li-content">
                <p class="selected-group">
                  {{ item.groupName }}
                </p>
              </div>
              <i class="icon-close iconfont delete" @click="del(index, item.id)" />
            </a-radio-button>
          </a-radio-group>
          <ComNull v-else :show-img="false" type="2" desc="请选择小组" />
        </div>

        <!-- 已选讲次 -->
        <div class="batch-wap-right-last" v-if="currentGroupId && lessonsList.length > 0">
          <div class="head">
            <div class="hasSelect">
              选择讲次
            </div>
          </div>
          <a-spin
            :spinning="spinning"
            :style="{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              'overflow-y': 'scroll'
            }"
          >
            <a-checkbox-group v-model="submitObj[currentGroupId].lessonIds" v-if="lessonsList.length > 0">
              <a-row v-for="item in lessonsList" :key="item.id">
                <a-checkbox :value="item.id">
                  {{ `第${item.num}讲` }} {{ item.name }}
                </a-checkbox>
              </a-row>
            </a-checkbox-group>
          </a-spin>
          <ComNull v-if="!spinning && lessonsList.length === 0" :show-img="false" type="2" desc="请选择小组" />
        </div>
      </div>
    </div>

    <template slot="footer">
      <a-button @click="handleCancel">
        取消
      </a-button>
      <a-button type="primary" @click="onOK">
        确认选择
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import YearSemesterSelect from '@/components/YearSemesterSelect.vue'
import ComNull from '@/components/ComNull/ComNull'
import mixins from '@/utils/mixins'
import moment from 'moment'

// 小组列表
const columns = [
  {
    dataIndex: 'groupName',
    key: 'groupName',
    title: '小组名称',
    scopedSlots: { customRender: 'groupName' },
    width: 100
  },
  {
    dataIndex: 'studentNum',
    key: 'studentNum',
    align: 'center',
    title: '人数',
    scopedSlots: { customRender: 'studentNum' },
    width: 50
  },
  {
    slots: { title: 'courseTime' },
    scopedSlots: { customRender: 'openTime' },
    width: 110
  },
  {
    dataIndex: 'itvCourseName',
    key: 'itvCourseName',
    title: '学习机课程名称',
    scopedSlots: { customRender: 'itvCourseName' },
    width: 120
  },
  {
    title: '学年学期',
    scopedSlots: { customRender: 'semester' },
    width: 80
  },
  {
    title: '期次',
    scopedSlots: { customRender: 'periodStr' },
    width: 80
  },
  {
    scopedSlots: { customRender: 'classCycleStr' },
    title: '周期',
    width: 80
  },
  {
    scopedSlots: { customRender: 'timeIntervalStr' },
    title: '时段',
    width: 50
  }
]

export default {
  mixins: [mixins],

  components: {
    YearSemesterSelect,
    ComNull
  },

  props: {
    initGroupLesson: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      scroll: {
        x: 760,
        y: 'calc(100vh - 254px - 145px)'
      },
      currentGroupId: null,
      searchGroupName: '',
      searchItvCourseName: '',
      year: '',
      semester: '',
      tesTableData: [], // 我的小组列表
      loading: false,
      columns,
      pagination: {
        pageSize: 50,
        total: 0,
        current: 1
      },
      selectedRows: [],
      selectedRowKeys: [],
      submitObj: {},
      lessonsList: [],
      spinning: false
    }
  },

  watch: {
    visible: {
      handler(nV) {
        if (nV) {
          // 弹窗的选择小组筛选内容复用了小组与学员的检索内容，所以打开关闭时都需要清除筛选项
          this.doReset()
          this.initData()
          this.$nextTick(() => {
            try {
              const wH = Math.round(document.body.clientHeight - 399)
              this.scroll.y = wH + 'px'
            } catch {
              throw new Error('缩放列表高度计算错误')
            }
          })
        } else {
          this.doReset()
        }
      },
      immediate: true
    },
    selectedRows() {
      this.selectedRowKeys = this.selectedRows.map(i => i.id)
    },
    currentGroupId: {
      handler(nV) {
        if (nV) {
          this.getLessonsByClass()
        }
      },
      immediate: true
    }
  },

  filters: {
    formatTimeStr(record) {
      if (record.beginTime.indexOf('1970') !== -1 ||
      record.beginTime.indexOf('1970') !== -1) {
        return '--'
      }
      return `${moment(record.beginTime).format('YYYY.MM.DD')}-${moment(record.endTime).format('YYYY.MM.DD')}`
    }
  },

  methods: {
    async getLessonsByClass() {
      try {
        this.spinning = true
        const classTypeId = this.selectedRows.find(k => k.id === this.currentGroupId).classTypeId
        const res = await this.$service.supervision.getLessonsByClassId({ classTypeId })
        this.lessonsList = res.map(k => ({
          ...k,
          id: k.id + '*' + k.num
        }))
        this.spinning = false
      } catch (err) {
        console.error('获取讲次出错')
      }
    },
    /**
     * 初始化数据
     */
    initData() {
      try {
        this.selectedRowKeys = [...new Set(this.initGroupLesson.map(k => (String(k.id).includes('_') ? k.id.split('_')[0] - 0 : k.id)))]
        // 默认获取第一个小组下的讲次
        if (this.selectedRowKeys.length > 0) this.currentGroupId = this.selectedRowKeys[0]
        if (this.initGroupLesson.length > 0) {
          // 有缓存取缓存
          this.initGroupLesson.forEach(k => {
            const kId = String(k.id).includes('_') ? k.id.split('_')[0] - 0 : k.id
            if (!this.selectedRows.find(row => row.id === kId)) {
              this.selectedRows.push({
                id: kId,
                groupName: k.groupName,
                classTypeId: k.classTypeId
              })
            }

            const lessonId = String(k.id).includes('_') ? k.id.split('_')[1] : null
            if (!this.submitObj[kId]) {
              this.$set(this.submitObj, kId, {
                groupId: kId,
                groupName: k.groupName,
                lessonIds: [],
                classTypeId: k.classTypeId
              })
              if (lessonId) this.submitObj[kId].lessonIds.push(lessonId)
            } else {
              if (lessonId) this.submitObj[kId].lessonIds.push(lessonId)
            }
          })
        }
        this.getGroupList()
      } catch (err) {
        console.log(err)
      }
    },
    onSelect(record, selected, selectedRows) {
      if (selected) {
        selectedRows && selectedRows.forEach(element => {
          if (this.selectedRows.findIndex(i => i.id === element.id) < 0) {
            this.selectedRows.push(element)
          }
        })
        // 选中行时，如果是已选小组只有这一个，那么小组也需要被选中
        if (this.selectedRows.length === 1) this.currentGroupId = record.id
        this.$set(this.submitObj, record.id, {
          groupId: record.id,
          groupName: record.groupName,
          lessonIds: [],
          classTypeId: record.classTypeId
        })
      } else {
        const idx = this.selectedRows.findIndex(i => i.id === record.id)
        this.selectedRows.splice(idx, 1)
        if (this.selectedRows.length === 0 || this.currentGroupId === record.id) {
          this.currentGroupId = null
          this.spinning = false
        }
        delete this.submitObj[record.id]
        if (this.selectedRows.length > 0) {
          this.currentGroupId = this.selectedRows[0].id
        } else {
          this.lessonsList = []
        }
      }
    },
    onSelectAll(selected, selectedRows, changeRows) {
      if (selected) {
        selectedRows && selectedRows.forEach(element => {
          if (this.selectedRows.findIndex(i => i.id === element.id) < 0) {
            this.selectedRows.push(element)
          }
        })
        changeRows.forEach(k => {
          this.$set(this.submitObj, k.id, {
            groupId: k.id,
            groupName: k.groupName,
            lessonIds: [],
            classTypeId: k.classTypeId
          })
        })
        // 全选时，如果没有当前激活的小组，那就需要选中第一个
        if (!this.currentGroupId) {
          this.currentGroupId = selectedRows[0].id
        }
        // if (changeRows.length === this.tesTableData.length) {
        // 一次性全选时
        // this.currentGroupId = changeRows[0].id
        // }
      } else {
        changeRows.forEach(element => {
          const idx = this.selectedRows.findIndex(i => i.id === element.id)
          if (idx > -1) {
            this.selectedRows.splice(idx, 1)
          }
        })
        this.currentGroupId = null
        this.submitObj = Object.assign({})
        this.lessonsList = []
        this.spinning = false
      }
    },
    onChange(selectedRowKeys, selectedRows) {
      // selectedRowKeys 设置要配合change事件
      selectedRows && selectedRows.forEach(element => {
        if (this.selectedRows.findIndex(i => i.id === element.id) < 0) {
          this.selectedRows.push(element)
        }
      })
    },
    handleCancel() {
      this.$emit('update:visible', false)
    },
    updateYearAndSemester(opts) {
      this.year = opts.year === '全部' ? '' : opts.year
      this.semester = opts.semester === '全部' ? '' : opts.semester
    },
    selectionChange(val, key) {
      this.$store.commit(`common/setActive${key}`, val)
    },
    handleChangePageNum(current, pageSize) {
      console.log('handleChangePageNum', current)
      this.pagination.current = current
      this.pagination.pageSize = pageSize
      this.getGroupList()
    },
    /**
     * 行点击查询数据
     */
    customRowFun(record) {
      return {
        on: {
          click: () => this.changeStudentChecked(record)
        }
      }
    },
    /**
     * 改变组选中状态
     */
    changeStudentChecked(record) {
      const index = this.selectedRows.findIndex(item => item.id === record.id)
      if (~index) {
        this.selectedRows.splice(index, 1)
        if (this.selectedRows.length === 0 || this.currentGroupId === record.id) {
          this.currentGroupId = null
          this.spinning = false
        }
        delete this.submitObj[record.id]
        if (this.selectedRows.length > 0) {
          this.currentGroupId = this.selectedRows[0].id
        } else {
          this.lessonsList = []
        }
      } else {
        this.selectedRows.push(record)
        // 选中行时，如果是已选小组只有这一个，那么小组也需要被选中(默认获取小组下的讲次)
        if (this.selectedRows.length === 1) this.currentGroupId = record.id
        this.$set(this.submitObj, record.id, {
          groupId: record.id,
          groupName: record.groupName,
          lessonIds: [],
          classTypeId: record.classTypeId
        })
      }
    },
    /**
     * 获取我的小组列表
     */
    async getGroupList() {
      this.loading = true
      const searchParams = {
        timeInterval: this.activeTimeInterval || -1,
        classCycle: this.activeClassCycle || -1,
        period: this.activePeriod,
        groupName: (this.searchGroupName).trim(),
        itvCourseName: (this.searchItvCourseName).trim(),
        year: this.year,
        semester: this.semester,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        hideStatus: 0
      }
      this.$service.groupManage.getGroupList(searchParams).then(res => {
        this.loading = false
        this.pagination = {
          ...this.pagination,
          total: res.itemTotal,
          current: res.pageNum
        }
        res.list && res.list.forEach((item, index) => {
          item.index = this.pagination.total - (this.pagination.current - 1) * this.pagination.pageSize - index
        })
        this.tesTableData = res.list || []
      }).catch(err => {
        this.loading = false
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    clearAll() {
      const _this = this
      if (this.selectedRows.length < 1) return
      this.$confirm({
        title: '是否移除已选全部小组？',
        zIndex: 3000,
        onOk() {
          _this.selectedRows = []
          _this.submitObj = Object.assign({})
          _this.lessonsList = []
          _this.spinning = false
        }
      })
    },
    /**
     * 小组搜索
     */
    doSearch() {
      this.pagination.current = 1
      this.getGroupList()
    },
    /**
     * @description: 删除小组
     * @param {*} idx
     * @return {*}
     */
    del(idx, groupId) {
      this.selectedRows.splice(idx, 1)
      delete this.submitObj[groupId]
      // 删除当前选中时同时清空讲次数据
      this.selectedRowKeys = this.selectedRowKeys.filter(item => !(item === groupId))
      this.currentGroupId = null
      if (this.selectedRows.length > 0) {
        this.currentGroupId = this.selectedRows[0].id
      } else {
        this.lessonsList = []
      }
    },
    // 重置筛选信息
    doReset() {
      this.searchGroupName = ''
      this.searchItvCourseName = ''
      this.$store.commit(`common/setActivePeriod`, -2)
      this.$store.commit(`common/setActiveTimeInterval`, -1)
      this.$store.commit(`common/setActiveClassCycle`, -1)
      this.searchStuKeyword = ''
      this.activeClassCycle = ''
      this.$refs.yearAndSemester && this.$refs.yearAndSemester.clearSelect()
      this.year = ''
      this.semester = ''
      // console.log('重置')
      this.pagination.current = 1
    },
    reset() {
      this.doReset()
      this.getGroupList()
    },
    onOK() {
      // 提交数据处理
      const groupLessonsList = []
      Object.keys(this.submitObj).forEach(groupId => {
        const groupInfo = this.submitObj[groupId]
        let lessonIds = []
        if (groupInfo) {
          lessonIds = groupInfo.lessonIds
        }
        if (groupInfo && lessonIds) {
          if (lessonIds && lessonIds.length > 0) {
            lessonIds.forEach(lessonId => {
              groupLessonsList.push({
                groupName: groupInfo.groupName,
                composeName: `${groupInfo.groupName}(第${lessonId.split('*')[1]}讲)`,
                id: groupInfo.groupId + '_' + lessonId,
                classTypeId: groupInfo.classTypeId
              })
            })
          } else {
            groupLessonsList.push({
              groupName: groupInfo.groupName,
              composeName: groupInfo.groupName,
              id: groupInfo.groupId,
              classTypeId: groupInfo.classTypeId
            })
          }
        }
      })
      this.$emit('onOk', groupLessonsList)
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';
// :deep(.ant-table-header.ant-table-hide-scrollbar) {
//   margin-right: -15px;
// }

.table-wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    flex: 1;
    overflow: hidden;
    background: @gray-10;
    // 弹窗上下外边距40px
    height: calc(100% - 53px - 65px - 33px - 16px - 40px - 40px);
    .filter-selection {
      margin-right: 8px;
    }
    .mr8 {
      margin-right: 8px;
    }
    .table-filter {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      justify-content: space-between;

      .filter-title {
        margin-right: 12px;
      }

      .filter-title:not(:first-child) {
        margin-left: 20px;
      }
    }
    .list-box {
      flex: 1;
      display: flex;
      flex-direction: row;
      overflow: hidden;
    }
    .group-list-box {
      flex: 1;
      flex-direction: column;
      overflow: hidden;
      height: 100%;
      padding-right: 10px;
      .table {
        flex: 1;
        overflow: auto;
      }
      .pagination {
        text-align: right;
        padding-top: 12px;
      }
    }
    .batch-wap-right{
        display: flex;
        flex-direction: column;
        width: 260px;
        border-left: 1px solid @gray-7;
        padding: 0 6px 24px 24px;
        .group-lesson-tip {
          margin-bottom: 12px;
          position: relative;
          color: 70788c;
          font-size: 12px;
          letter-spacing: 0.04em;
          padding-left: 18px;
          .info-icon {
              position: absolute;
              left: 0;
              top: 2px;
              font-size: 14px;
              fill: #70788c;
          }
        }
        .head{
            padding-right: 10px;
            display: flex;
            font-size: 14px;
            line-height: 27px;
            .hasSelect{
                flex: 1;
                color: @gray-2;
                font-weight: bold;
            }
            .clearAll{
                color: @blue-1;
                text-align: right;
                cursor: pointer;
            }
        }
        .radio-group {
            overflow-y: auto;
            display: flex;
            flex-wrap: wrap;
            padding-right: 12px;
            overflow-x: hidden;
            .ant-radio-button-wrapper-checked {
              background: #3262FD;
              .selected-group {
                color: #fff !important;
              }
            }
            .ant-radio-button-wrapper:not(:first-child)::before {
              display: none !important;
            }
            .radio-item {
                display: flex;
                width: 100%;
                color: #505873;
                align-items: center;
                justify-content: space-between;
                border-radius: 6px;
                margin-bottom: 12px;
                position: relative;
                border: 1px solid #3262FD;
                &:hover {
                  position: relative;
                  width: 120%;
                  background: #3262FD;
                  .selected-group {
                    color: #fff !important;
                  }
                  .delete{
                    color: #fff;
                  }
                }
                .li-content{
                    height: 100%;
                    .selected-group {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: block;
                        white-space: nowrap;
                        font-size: 14px;
                        color: @gray-2;
                        height: 100%;
                        width: 180px;
                    }
                }
                .delete{
                    font-size: 14px;
                    margin-right: 11px;
                    color: @gray-4;
                    cursor: pointer;
                    display: none;
                    position: absolute;
                    right: -5px;
                    top: 0;
                }
                &:hover{
                    .delete{
                        display: initial;
                    }
                }
            }
        }
    }
    .batch-wap-right-last{
      display: flex;
      flex-direction: column;
      width: 260px;
      border-left: 1px solid @gray-7;
      padding: 0 6px 24px 24px;
      .head{
          padding-right: 10px;
          display: flex;
          font-size: 14px;
          line-height: 40px;
          margin-bottom: 12px;
          .hasSelect{
              flex: 1;
              color: @gray-2;
              font-weight: bold;
          }
          .clearAll{
              color: @blue-1;
              text-align: right;
              cursor: pointer;
          }
      }
      .ant-checkbox-wrapper {
        width: 230px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
        white-space: nowrap;
      }
    }
    .ant-table-wrapper {
      max-height: calc(100% - 68px);
      height: calc(100% - 68px);
      // overflow: auto;
      :deep(tr) {
        line-height: 32px;
        .text-num{
          display: block;
          text-align: center;
        }
        .text-limit1 {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .text-limit {
          // padding: 0px 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      :deep(.row-select) {
          color: #3262FD;
      }

      .plan-name {
        min-width: 120px;
      }

      .action {
        display: flex;
        a {
          margin-right: 16px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
}

.pagination {
    // position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 72px;
    background-color: white;
    padding-right: 18px;
}
</style>